import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
// import { baseURL_dev } from '@/config/baseURL';
import router from "@/router";
class HttpRequest {
  private readonly baseUrl: string;
  constructor() {
    // this.baseUrl ="http://43.133.12.97:9000/Home"
    this.baseUrl = "https://8.211.140.223:443/userApi/";
    // this.baseUrl = "https://galaxyquantitative.com/userApi/"
  }
  getInsideConfig() {
    let token = localStorage.getItem("appToken");
    if (token) {
      token = "Bearer " + token;
    } else {
      token = "";
    }
    const config = {
      baseURL: this.baseUrl,
      timeout: 30000,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: token,
      },
    };
    return config;
  }

  interceptors(instance: AxiosInstance) {
    // 请求拦截
    instance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        // 添加全局的loading..
        // 请求头携带token
        return config;
      },
      (error: AxiosError) => {
        return Promise.reject(error);
      }
    );

    //响应拦截
    instance.interceptors.response.use(
      (res: AxiosResponse) => {
        const { data } = res;
        return data;
      },
      (error: AxiosError) => {
        if (error.response && error.response.status === 401) {
          const newToken = localStorage.getItem("appToken");
          if (newToken) {
            localStorage.removeItem("appToken");
            router.push({ path: "/login" });
          } else {
            localStorage.removeItem("appToken");
            router.push("/login");
          }
        }
      }
    );
  }

  request(options: AxiosRequestConfig) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance);
    return instance(options);
  }
}

const http = new HttpRequest();
export default http;
